module.exports = __webpack_public_path__ + "static/media/hongkong.78e763fa.png";